import { editorViewCtx } from '@milkdown/core';
import { useEffect, useRef } from 'react';
// There is still time to avert your eyes 🙈
//
// When the editor is first rendered and it is editable, we want to set focus to it.
export function useSetInitialFocus(getEditor, initialIsEditableValue) {
    const initialIsEditableRef = useRef(initialIsEditableValue); // store value on initial mount
    const hasRunRef = useRef(false); // only run once
    // based on observation getEditor changes on every render, but we only want to set the focus once
    //   on the initial mount when isEditable is true
    useEffect(() => {
        if (!initialIsEditableRef.current || hasRunRef.current) {
            return;
        }
        const editor = getEditor();
        // only check for the initial value of is editable
        if (!editor) {
            return;
        }
        hasRunRef.current = true;
        editor.action(ctx => {
            ctx.get(editorViewCtx).focus();
        });
    }, [getEditor]);
}
//# sourceMappingURL=use_set_initial_focus.js.map